import { render, staticRenderFns } from "./LoginCardTemplate.vue?vue&type=template&id=53dde0f0&scoped=true&lang=pug"
var script = {}
import style0 from "./LoginCardTemplate.vue?vue&type=style&index=0&id=53dde0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dde0f0",
  null
  
)

export default component.exports